import { useTranslation } from 'react-i18next'
import { X } from 'lucide-react'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogTitle,
} from '@quebon/ui/components/dialog'

interface CertificateModalProps {
  open: boolean
  onClose: () => void
}

export default function CertificateModal({ open, onClose }: CertificateModalProps) {
  const { t: mt } = useTranslation('marketing')

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onClose()}>
      <DialogContent
        showCloseButton={false}
        className="max-w-sm sm:max-w-sm max-h-[90vh] overflow-y-auto"
      >
        <DialogTitle className="text-xl font-semibold">
          {mt('certificate.title')}
        </DialogTitle>
        <DialogClose
          aria-label={mt('certificate.close')}
          className="absolute top-3 right-3 inline-flex h-9 w-9 items-center justify-center rounded-md text-gray-600 hover:bg-gray-100 hover:text-gray-900 outline-none focus-visible:ring-2 focus-visible:ring-foreground/20"
        >
          <X className="h-6 w-6" strokeWidth={2.25} />
        </DialogClose>
        <img src="/certificate.png" alt={mt('certificate.imageAlt')} className="w-full h-auto" />
      </DialogContent>
    </Dialog>
  )
}
